import { Popover, Collapse } from "antd";
import { Link } from "react-router-dom";


const DoctorPopoverItem = (
    <ul className="doctor-popover-list">
        <li className="mb-1">
            <Link to="/PharmacyPurchase1"  className="doctor-link" style={{ textDecoration: "none", color: "#fff", }}>
                Purchase
            </Link>
        </li>
        <li>
            <Link to="/PurchaseOrder" className="doctor-link" style={{ textDecoration: "none", color: "#fff" }}>
                Add Purchase
            </Link>
        </li>
        <li>
            <Link to="/PharmacyPurchasereturn" state={{ openModal: true }} className="doctor-link" style={{ textDecoration: "none", color: "#fff" }}>
                Purchase Return
            </Link>
        </li>
    </ul>
);

const popStyle = `

.sidebar-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.8rem 0rem;
  background: none !important;
  transition: all .3s ease-in;
  cursor: pointer;
  border-radius: 6px;
}

.sidebar-icon-wrapper:hover {
  background: #374151 !important;
}

.doctor-popover .ant-popover-inner {
  background-color: #213343;
  color: white;
  border-radius: 8px;
  min-width: 120px;
  padding: 0.5rem;
}

.doctor-popover-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.doctor-link {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 5px;
  font-size: 14px;
  transition: all .3s ease-in;
}

.doctor-link:hover {
  background: #374151 !important;
}


`;


const PurchasePopoverItems = () => {
    return (
        <>
            <style>{popStyle}</style>
            <Popover
                placement="right"
                trigger="hover"
                overlayClassName="doctor-popover"
                content={DoctorPopoverItem}
            >
                <div className="sidebar-icon-wrapper">
                    <img
                        style={{ width: ".8rem", cursor: "pointer" }}
                        src="../Images/Patients.svg"
                        alt="Patient"
                    />
                </div>
            </Popover>
        </>
    );
};

export default PurchasePopoverItems;